export const RecommendationsAccordionStyle = (props: any) => {
  return `
    .accordion-item-separator {
      display: none;
    }

    hr {
      margin: 0px !important;
    }

    hr.bold {
      border: 1px solid ${props.theme.marginsBorder};
    }

    .accordion-item button {
      background: ${props.theme.cardsColor};
      padding: 40px;
      border-radius: 5px;
      font-size: 24px;
    }

    .item-visible [data-u1-accordion='content'] {
      margin: 0px;
      padding: 0px 40px 40px 40px;
      background: ${props.theme.cardsColor};
    }
  `;
};
